import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Popover,
  Badge,
  Button,
  Modal,
  message,
  Divider,
  Spin,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { getMySqlDate, dateInDetail } from "utils/Date";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import {
  getUserRoleId,
  getMenuList,
  getClientid,
  getUserInfo,
} from "redux/selectors";
// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleProcessingModal, toggleSuccessModal } from "redux/actions";
import RejectReasonModal from "./RejectReasonModal";
import { useTranslation } from "react-i18next";
import download from "downloadjs";
import ViewDocument from "reusableComponent/Popup/viewDocument";

const StyledRowContainer = styled(Card)`
  ${({ color }) => color && `background: ${color}`};
  border-radius: 3px;
  .ant-card-body {
    padding: 2px 5px;
  }
  svg {
    height: 15px !important;
    vertical-align: middle;
    fill: ${COLORS.WHITE} !important;
  }
  .staff-name {
    padding-left: 3px;
    font-size: 0.7rem;
    color: ${COLORS.WHITE};
    font-weight: bold;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-top: 1px;
  }
`;

const StyledButton = styled(Button)`
  color: ${COLORS.WHITE};
  border: none;
  width: 120px;
  margin: 10px;
  border-radius: 5px;
  width: initial;
  &.ant-btn[disabled] {
    color: white;
  }
`;

const StyledLeaveDetailsPopover = styled.div`
  width: 350px;
  padding: 5px 1rem 1rem;
  .ant-col {
    padding: 3px;
  }
  .ant-col:nth-child(1) {
    font-weight: bold;
  }
`;

const StyledLeaveDetailsPopoverFooter = styled.div`
  text-align: right;
  margin-right: -15px;
  .cancel-request {
    margin-right: 10px;
    padding: 0px 10px;
    background: #dbdbdb;
    margin-bottom: 10px;
  }
`;

const StyledDivider = styled(Divider)`
  margin: 5px;
`;

const StyledAmmendmentTitle = styled.div`
  padding: 10px 0px 7px 0px;
`;

function StaffLeaveIndicatorInCalendar({
  leaveDetails,
  isStaff,
  children,
  reloadList,
  displayLeaveDetail,
  updateProcessingModal,
  updateSuccessModal,
  openEditLeaveModal,
  EditLeaveModal,
  userRoleId,
  handleEditIconClick,
  Days,
  menuList,
  ClientId,
  userInfo,
}) {
  console.log("leaveDetails in calendar-->", leaveDetails);
  const { t } = useTranslation();
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const [displayDeclineReasonModal, toggleDeclineReasonModalVisibility] =
    useState(false);

  const higherOfficialsEmailId = userInfo?.higherOfficialsList?.filter(
    (item) => item?.role === "CEO" || item?.role === "HR" 
  )?.map((item) => item?.email);

  const isHigherOfficials = !!higherOfficialsEmailId?.includes(
    userInfo?.userid
  );
  const [preview, setPreview] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [loading, setLoading] = useState(false);

  const {
    user_leave_id,
    status_name,
    status_id,
    start_date,
    end_date,
    reason,
    name,
    number_of_days,
    leave_category_name,
    having_cancel_request,
    new_start_date,
    new_end_date,
    new_number_of_days,
    relievername,
    approved_rejected_byName,
    approved_rejected_by_higherofficials,
    new_approved_rejected_byName,
    new_approved_rejected_by_higherofficials,
    reporting_manager,
    fileName,
  } = leaveDetails;
  const {
    date_th: start_date_th,
    shortMonthName: start_month,
    year: start_year,
  } = dateInDetail(
    having_cancel_request === "1"
      ? start_date
      : new_start_date === "null" ||
        new_start_date === null ||
        new_start_date === ""
      ? start_date
      : new_start_date
  );
  const {
    date_th: end_date_th,
    shortMonthName: end_month,
    year: end_year,
  } = dateInDetail(
    having_cancel_request === "1"
      ? end_date
      : new_end_date === "null" || new_end_date === null || new_end_date === ""
      ? end_date
      : new_end_date
  );

  const {
    date_th: new_start_date_th,
    shortMonthName: new_start_month,
    year: new_start_year,
  } = dateInDetail(new_start_date);
  const {
    date_th: new_end_date_th,
    shortMonthName: new_end_month,
    year: new_end_year,
  } = dateInDetail(new_end_date);
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const hide = () => {
    setOpen(false);
  };

  const handlePreviewClick = async (data) => {
    try {
      const preview = data?.fileName?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          user_leave_id: data?.user_leave_id,
          method: "file",
          userId: data?.userid,
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const approveRejectCancelLeave = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request = having_cancel_request === "1" ? true : false,
    isIntermediateStep = false
  ) => {
    return new Promise(async (resolve) => {
      const payload = {
        userid: leaveDetails?.userid,
        user_leave_id,
        status_id: statusId,
        declined_reason,
        is_cancel_request: is_leave_cancel_request,
        start_date: getMySqlDate(new_start_date ? new_start_date : start_date),
        end_date: getMySqlDate(new_end_date ? new_end_date : end_date),
        approved_rejected_by_higherofficials: isHigherOfficials
          ? userInfo?.fullname
          : "",
      };
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          userid: leaveDetails?.userid,
          user_leave_id,
          status_id: statusId,
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: getMySqlDate(
            new_start_date ? new_start_date : start_date
          ),
          end_date: getMySqlDate(new_end_date ? new_end_date : end_date),
          approved_rejected_by_higherofficials: isHigherOfficials
            ? userInfo?.fullname
            : "",
        }
      );
      updateProcessingModal(false);
      if (code === STATUS_CODE.SUCCESS && isIntermediateStep) {
        // Level 1 step of a combined approval; the level 2 call follows.
      } else if (code === STATUS_CODE.SUCCESS) {
        const cancelRequestMessage = t(
          `Leave amendment request has been ${
            statusId === "5" ? "accepted" : "declined"
          }.`
        );
        updateSuccessModal({
          visibility: true,
          message: is_leave_cancel_request
            ? cancelRequestMessage
            : t(
                `Leave has been ${
                  statusId === "5"
                    ? "approved"
                    : statusId === "6"
                    ? "declined"
                    : "cancelled"
                } successfully.`
              ),
        });
        reloadList();
        // Call webhook API
      } else {
        message.error(t("Something went wrong. Please try again."));
      }
      resolve(code);
    });
  };

  const confirmOperation = (statusId) => {
    // A "5" (approve) request should only fully close the leave when the
    // higher official (Level 2) approves. A Level 1 approver's click keeps
    // the leave at status "4" (pending) so it surfaces for Level 2 approval.
    const resolvedStatusId =
      statusId === "5" ? (isHigherOfficials ? "5" : "4") : statusId;

    Modal.confirm({
      icon: "",
      content: t(
        `Are you sure you want to ${
          statusId === "5" ? "approve" : statusId === "6" ? "decline" : "cancel"
        } leave?`
      ),
      okText: t("YES"),
      cancelText: t("No"),
      onOk: async () => {
        return new Promise(async (resolve) => {
          // When the same user is both the level 1 and level 2 approver,
          // record the level 1 approval first, then the final level 2 approval.
          if (
            resolvedStatusId === "5" &&
            isLevel1Approver &&
            !level1Approved
          ) {
            const level1Code = await approveRejectCancelLeave(
              "4",
              "",
              undefined,
              true
            );
            if (level1Code !== STATUS_CODE.SUCCESS) return resolve();
          }
          await approveRejectCancelLeave(resolvedStatusId);
          resolve();
        }).catch((err) => console.log("[confirmOperation] Error -->", err));
      },
    });
  };

  const approveLeaveCancelRequest = (approve) => {
    Modal.confirm({
      icon: "",
      content: t(
        `Are you sure you want to ${
          approve === true ? "approve" : "reject"
        } leave amendment application?`
      ),
      okText: t("YES"),
      cancelText: t("No"),
      onOk: async () => {
        return new Promise(async (resolve) => {
          await approveRejectCancelLeave(approve ? "5" : "9", "", true);
          resolve();
        }).catch((err) =>
          console.log("[approveLeaveCancelRequest] Error-->", err)
        );
      },
    });
  };

  const closeDeclineReasonModal = async (reason) => {
    if (reason) await approveRejectCancelLeave("6", reason);
    toggleDeclineReasonModalVisibility(false);
  };

  const iconStyle = {
    fontSize: "1rem",
    padding: "10px",
    paddingRight: "0px",
    cursor: "pointer",
  };

  // Approve button should only show:
  //  - to a Level 1 approver, when Level 1 hasn't approved yet, OR
  //  - to the higher official (Level 2), once Level 1 HAS approved.
  const isAmended =
    having_cancel_request === "1" || having_cancel_request === 1;

  // Amended leaves track their own approvals in the new_* fields, independent
  // of the original leave's approval state.
  const level1ApproverName = isAmended
    ? new_approved_rejected_byName
    : approved_rejected_byName;
  const level2ApproverName = isAmended
    ? new_approved_rejected_by_higherofficials
    : approved_rejected_by_higherofficials;

  const level1Approved = !!level1ApproverName;
  const level2Approved = !!level2ApproverName;

  const displayStatus = isAmended
    ? level1Approved
      ? t("Pending by Level 2 Approval")
      : t("Pending by Level 1 Approval")
    : status_name;

  // The logged-in user is the level 1 approver (reporting manager) of this leave.
  const isLevel1Approver =
    !!reporting_manager && reporting_manager === userInfo?.userid;

  // A higher official who is also this leave's reporting manager can approve
  // before level 1 approval (they are the level 1 approver).
  const canApprove =
    (!level1Approved && (!isHigherOfficials || isLevel1Approver)) ||
    (isHigherOfficials && level1Approved && !level2Approved);

  const content = (
    <>
      <Spin spinning={loading}>
        <StyledLeaveDetailsPopover>
          <Row>
            <Col span={20}>
              <h5>
                <Badge
                  status="success"
                  size="small"
                  color={
                    status_id === "4"
                      ? COLORS.PENDING_LEAVE
                      : having_cancel_request === "1"
                      ? COLORS.PENDING_LEAVE
                      : status_id === "5"
                      ? COLORS.APPROVED_LEAVE
                      : ""
                  }
                />
                {name}
              </h5>
            </Col>
            <Col span={4} className="align-right">
              {isStaff &&
                status_id === "4" &&
                Menulist?.find(
                  (item) => item?.key === "mycalendar" && item?.permission?.edit
                ) && (
                  <EditOutlined
                    style={iconStyle}
                    onClick={() => {
                      handleEditIconClick();
                      openEditLeaveModal(leaveDetails);
                      hide();
                    }}
                  />
                )}
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>{t("From date:")}</Col>
            <Col span={16}>
              {start_date_th} {start_month} {start_year}
            </Col>
          </Row>

          <Row gutter={20}>
            <Col span={8}>{t("To date:")}</Col>
            <Col span={16}>
              {end_date_th} {end_month} {end_year}
            </Col>
          </Row>

          <Row gutter={20}>
            <Col span={8}>{t("No of days")}:</Col>
            <Col span={16}>
              {having_cancel_request === "1"
                ? number_of_days
                : new_number_of_days === null ||
                  new_number_of_days === "" ||
                  new_number_of_days === "null"
                ? number_of_days
                : new_number_of_days}
            </Col>
          </Row>

          {having_cancel_request === "1" && (
            <>
              <Row gutter={20}>
                <Col span={24}>
                  <StyledDivider />
                  <StyledAmmendmentTitle>
                    {t("Amendment Details")}
                  </StyledAmmendmentTitle>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={8}>{t("From date:")}</Col>
                <Col span={16}>
                  {new_start_date_th} {new_start_month} {new_start_year}
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={8}>{t("To date:")}</Col>
                <Col span={16}>
                  {new_end_date_th} {new_end_month} {new_end_year}
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={8}>{t("No of days:")}</Col>
                <Col span={16}>{new_number_of_days}</Col>
              </Row>

              <Row>
                <Col span={24}>
                  <StyledDivider />
                </Col>
              </Row>
            </>
          )}

          <Row gutter={20}>
            <Col span={8}>{t("Status")}:</Col>
            <Col span={16}>{displayStatus}</Col>
          </Row>

          <Row gutter={20}>
            <Col span={8}>{t("Leave Type:")}</Col>
            <Col span={16}>{leave_category_name}</Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>{t("File Name")}</Col>
            <Col span={16} onClick={() => handlePreviewClick(leaveDetails)}>
              {fileName}
            </Col>
          </Row>
          {relievername !== "" && (
            <Row gutter={20}>
              <Col span={8}>Reliever:</Col>
              <Col span={16}>{relievername || "-"}</Col>
            </Row>
          )}

          {level1Approved && (
            <Row gutter={20}>
              <Col span={8}>{t("Level 1 Approved by")}:</Col>
              <Col span={16}>{level1ApproverName}</Col>
            </Row>
          )}

          {level2Approved && (
            <Row gutter={20}>
              <Col span={8}>{t("Level 2 Approved by")}:</Col>
              <Col span={16}>{level2ApproverName}</Col>
            </Row>
          )}

          <Row gutter={20}>
            <Col span={8}>{t("Description")}:</Col>
            <Col span={16}>{reason}</Col>
          </Row>
        </StyledLeaveDetailsPopover>
        <StyledLeaveDetailsPopoverFooter>
          {!isStaff &&
            (status_id === "4" ||
              (status_id === "5" && having_cancel_request === "1")) &&
            canApprove &&
            Menulist?.find(
              (item) =>
                item.access === true &&
                item.path === "allapprovals" &&
                item.subMenu?.some(
                  (sub) =>
                    sub?.path === "approvals" && sub?.permission?.edit === true
                )
            ) && (
              <StyledButton
                type="primary"
                onClick={() => {
                  confirmOperation("5");
                  hide();
                }}
              >
                {t("Approve")}
              </StyledButton>
            )}
          {!isStaff &&
            Menulist?.find(
              (item) =>
                item.access === true &&
                item.path === "allapprovals" &&
                item.subMenu?.some(
                  (sub) =>
                    sub?.path === "approvals" && sub?.permission?.edit === true
                )
            ) && (
              <StyledButton
                type="primary"
                onClick={() => {
                  toggleDeclineReasonModalVisibility(true);
                  hide();
                }}
              >
                {t("Decline")}
              </StyledButton>
            )}
          {isStaff && (
            <StyledButton
              type="primary"
              disabled={having_cancel_request === "1"}
              onClick={(event) => {
                EditLeaveModal({
                  ...leaveDetails,
                  isCancel: true,
                });
                hide();
              }}
            >
              {" "}
              {having_cancel_request === "1"
                ? t("Amendment Requested")
                : status_id === "5"
                ? t("Amend Leave")
                : t("Cancel Leave")}
            </StyledButton>
          )}
        </StyledLeaveDetailsPopoverFooter>
      </Spin>
    </>
  );

  const leaveRow = () => {
    return (
      !isStaff && (
        <StyledRowContainer
          color={
            status_id === "4"
              ? COLORS.PENDING_LEAVE
              : having_cancel_request === "1"
              ? COLORS.PENDING_LEAVE
              : status_id === "5"
              ? COLORS.APPROVED_LEAVE
              : ""
          }
        >
          <Row>
            <Col span={24} className="staff-name">
              {name}
            </Col>
          </Row>
        </StyledRowContainer>
      )
    );
  };

  return (
    <>
      <Popover
        className="leave-detail-popover"
        content={content}
        placement="rightTop"
        trigger={"hover"}
        open={open}
        onOpenChange={handleOpenChange}
      >
        {/* {leaveRow()} */}
        {children}
      </Popover>
      {displayLeaveDetail && leaveRow()}
      <RejectReasonModal
        isOpenModal={displayDeclineReasonModal}
        closeModal={closeDeclineReasonModal}
      />
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  menuList: getMenuList(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
      updateSuccessModal: toggleSuccessModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(StaffLeaveIndicatorInCalendar);
